import React from 'react'
import { motion } from 'framer-motion'

interface QuickActionsProps {
  onRefresh: () => void
  isRefreshing: boolean
  className?: string
}

export const QuickActions: React.FC<QuickActionsProps> = ({
  onRefresh,
  isRefreshing,
  className = ''
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`${className}`}
    >
      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
        Быстрые действия
      </h3>
      
      <div className="space-y-3">
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={onRefresh}
          disabled={isRefreshing}
          className="w-full py-3 px-4 rounded-material-lg bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-medium transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-50 ripple shadow-lg"
        >
          {isRefreshing ? (
            <>
              <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                className="w-5 h-5 border-2 border-white border-t-transparent rounded-full"
              />
              <span>Обновление...</span>
            </>
          ) : (
            <>
              <motion.span
                whileHover={{ rotate: 180 }}
                transition={{ duration: 0.6 }}
              >
                🔄
              </motion.span>
              <span>Обновить данные</span>
            </>
          )}
        </motion.button>
        
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="w-full py-3 px-4 rounded-material-lg bg-gradient-to-r from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 text-gray-700 dark:text-gray-300 font-medium transition-all duration-300 hover:shadow-md ripple"
        >
          <span className="flex items-center justify-center gap-2">
            <span>📊</span>
            <span>Экспорт отчета</span>
          </span>
        </motion.button>
        
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="w-full py-3 px-4 rounded-material-lg bg-gradient-to-r from-emerald-100 to-emerald-200 dark:from-emerald-900/30 dark:to-emerald-800/30 text-emerald-700 dark:text-emerald-300 font-medium transition-all duration-300 hover:shadow-md ripple"
        >
          <span className="flex items-center justify-center gap-2">
            <span>📈</span>
            <span>Показатели качества</span>
          </span>
        </motion.button>
      </div>
    </motion.div>
  )
}